import { Box } from '@mui/material';
import akovaLogo from '@/assets/akova.png?format=webp&imagetools';
import akovaPayLogo from '@/assets/akova-pay.png?format=webp&imagetools';
import akovaCardLogo from '@/assets/akova-card.png?format=webp&imagetools';
import aLogo from '@/assets/a.png?format=webp&imagetools';
import akovaWhiteLogo from '@/assets/akova-white.png?format=webp&imagetools';
import { LogoProps } from './types';

const Logo = ({ type = 'default', height = '100px', width = 'auto' }: LogoProps) => {
  const logoSrc = (() => {
    switch (type) {
      case 'akova':
        return akovaLogo;
      case 'akova-pay':
        return akovaPayLogo;
      case 'akova-card':
        return akovaCardLogo;
      case 'akova-white':
        return akovaWhiteLogo;
      case 'default':
      default:
        return aLogo;
    }
  })();

  return (
    <Box
      component='img'
      src={logoSrc}
      alt={`${type} Logo`}
      sx={{
        display: 'block',
        margin: '0 auto',
        height,
        width,
        maxWidth: '100%',
        objectFit: 'contain'
      }}
    />
  );
};

export default Logo;
